<template>
  <div class="main-container">
    <News v-loading="loading" class="container newsInfo">
      <!-- <template v-slot:leftMenu>
      <LeftMenu />
    </template> -->
      <template v-slot:newsContent>
        <Breadcrumb :breadTitle="list" :breadList="breadList" class="pc" />
        <el-row :gutter="20" class="content">
          <el-col :sm="24" v-if="list">
            <div class="rich-text-wrapper">
              <h1>{{ list.title }}</h1>
              <div class="info">
                发布时间：{{ timeFormat(list.publish_time) }}
              </div>
              <NewsContent :newsInfo="list" />
            </div>
          </el-col>
        </el-row>
      </template>
      <template v-slot:rightMenu>
        <hotNews :title="title" :news="news" v-if="news && title" class="pc" />
      </template>
    </News>
  </div>
</template>
<script>
import News from "@/components/news/News.vue";
import hotNews from "@/components/news/hotNews.vue";
import { articleFindone, getArticleList } from "@/api/api.js";
import util from "@/libs/util.js";
import NewsContent from "@/components/news/news-Content";
import Breadcrumb from "@/components/breadcrumb";
import config from "../config.js";
export default {
  data() {
    return {
      list: null,
      id: null,
      loading: null,
      breadList: [],
      menu: null,
      news: null,
      title: null,
      menuId: null,
    };
  },
  components: {
    NewsContent,
    Breadcrumb,
    News,
    hotNews,
  },
  created() {
    
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    init() {
      this.menu = config.menuList;
      this.menuId = this.$route.params.menuId;
      this.id = this.$route.params.id;
      this.getNews();
      this.getHotNews();
    },
    updataDate() {
      this.breadList = [];
      this.getMenuByRoute();
      this.breadList.push({
        title: this.list.title,
        content: "",
        icon: "",
      });
    },
    getNews() {
      this.loading = true;
      articleFindone(this.id)
        .then((res) => {
          // 返回数据
          this.list = res.result;
          this.loading = false;
          this.updataDate();
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    getHotNews() {
      getArticleList({
       orgId:config.relationId,menu_pid:0,menu_id:this.menuId,pageNum:1,pageSize:4
      })
        .then((res) => {
          // 返回数据
          this.news = res.result.list;
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    getMenuByRoute() {
      this.breadList.push({
        title: "首页",
        content: "../../portal",
        icon: "iconyemiandaohang-shouye",
      });
      //根据路由判断左侧菜单的当前激活
      for (var i = 0; i < this.menu.length; i++) {
        var menu = this.menu[i];
        if (menu.isActive(this.$route)) {
          this.breadList.push(menu);
          this.title = menu.title;
          console.log("123", menu);
          return;
        }
        for (var j = 0; j < menu.subMenuList.length; j++) {
          var subMenu = menu.subMenuList[j];
          if (subMenu.isActive(this.$route)) {
            this.breadList.push(menu);
            this.breadList.push(subMenu);
            this.title = menu.title;
            console.log("213", menu, subMenu);
            return;
          }
          if (subMenu.subMenuList) {
            for (var z = 0; z < subMenu.subMenuList.length; z++) {
              var lastMenu = subMenu.subMenuList[z];
              if (lastMenu.isActive(this.$route)) {
                this.breadList.push(menu);
                this.breadList.push(subMenu);
                this.breadList.push(lastMenu);
                console.log("321", menu, subMenu, lastMenu);
                this.title = menu.title;
                return;
              }
            }
          }
        }
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
  },
};
</script>
<style lang="scss" scoped>
.newsInfo {
  min-height: 100%;
  padding-top: 20px;
}
.content {
  margin-top: 20px;
  padding: 30px;
  background-color: #fff;
  margin-bottom: 80px;
}
.rich-text-wrapper h1 {
  font-size: 22px;
  line-height: 32px;
}

.rich-text-wrapper .info {
  margin: 20px 0;
  font-size: 12px;
  line-height: 16px;
  color: #888;
}
.rich-text-wrapper .info::before {
  content: "来源：管理员";
}
@media (max-width: 767px) {
  .container{
    padding: 0px;
  }
  .content{
    margin-top:0px;
    margin-bottom:0px;
    padding: 20px 20px 0px;
  }
  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
}
</style>